export default __webpack_public_path__ + "static/media/keyvisual.6c15b79d.jpg";